import {Injectable} from '@angular/core';

import { Observable } from 'rxjs';

export interface DeactivationGuarded {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard  {
    canDeactivate(component: DeactivationGuarded): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}
